import { useState } from "react";
// import { captureException } from "src/lib/sentry/sentry";
import { FS, FSKey } from "src/general/constants/finiteStates";
import Auth from "@aws-amplify/auth";
import { useAuth } from "./auth-context";

const ERROR_MESSAGE = "Please enter a valid verification code.";
interface IVerifyOTP {
  user: any;
  code: string;
}
const getUserData = (user) => {
  const { storage, userDataKey } = user;
  if (!storage || !userDataKey || !storage[userDataKey]) {
    return null;
  }
  const userData = JSON.parse(storage[userDataKey]);
  return userData;
};

export const useVerifyOTP = () => {
  const { dispatch: authDispatch } = useAuth();
  const [value, setValue] = useState<FSKey>(FS.IDLE);

  const mutate = async ({ user, code }: IVerifyOTP) => {
    setValue(FS.LOADING);
    try {
      const resp = await Auth.sendCustomChallengeAnswer(user, code);
      const userData = getUserData(resp);
      authDispatch({ type: "set", user: resp, userData, newUser: false });
      if (resp && resp.signInUserSession) {
        setValue(FS.SUCCESS);
      } else {
        throw ERROR_MESSAGE;
      }
    } catch (e) {
      setValue(FS.ERROR);
      throw ERROR_MESSAGE;
      // captureException(e);
    }
  };

  return {
    mutate,
    state: {
      value,
      context: {
        FS,
      },
    },
  };
};
